import {
	Col,
	Row,
	ELanguage,
	Container as RCContainer
} from '@microfrontends/react-components'
import { useContext, useEffect, useState } from 'react'
import BottomSection from '../../components/CareerPath/Landing/BottomSection'
import ModalFormNumerology from '../../components/Numerology/ModalFormNumerology'
import Banner from '../../components/NumerologyV2/Banner'
import AppContext from '../../context/AppContext'
import { IArticle } from '../../services/hrInsider'
import NumerologyApi from '../../services/numerology'
import {
	IFamousPeople,
	TNumerologyDetail,
	TUserInfoInNumerlogy
} from '../../services/numerology/@type'
import { Container } from './Numerology.css'
import AboutNumerology from './components/AboutNumerology'
import Article from './components/Article'
import Books from './components/Books'
import FamousPeople from './components/FamosPeople'
import HistoryNumerology from './components/HistioryNumerology'
import RecommendJobs from './components/RecommendJobs'
import Responsibility from './components/Responsibility'
import RulingNumber from './components/RulingNumber'
import TopTitle from './components/TopTitle'
import { showLoginModal } from '../../helpers/buildLoginUrl'

const BASE_URL = process.env.VNW_BASE_URL
const API_DOMAIN = process.env.API_DOMAIN
const imgBaseUrl = process.env.IMAGE_BASE_URL
const IMAGE_SERVICE = imgBaseUrl + '/images/numerology'

const UTM = {
	utm_source: 'numerology',
	utm_medium: 'job-will-love',
	utm_campaign: 'home'
}
const CAREER_PATH_UTM = {
	utm_source_navi: 'banner',
	utm_medium_navi: 'session',
	utm_campaign_navi: 'CP2023'
}

const HR_INSIDER_TAG_ID = 1 // Tìm nghề không khó

interface INumerologyContainerProps {
	isRobot: boolean
	famousPeople: IFamousPeople[] | null
	articles: IArticle[]
}

export default function NumerologyContainer({
	isRobot,
	articles,
	famousPeople
}: INumerologyContainerProps) {
	const { user, languageCode = ELanguage.VI } = useContext(AppContext)
	const [openModal, setOpenModal] = useState(false)
	const [rulingNumberDetail, setRulingNumberDetail] = useState<
		(TNumerologyDetail & TUserInfoInNumerlogy) | null
	>(null)

	const handleOpenModal = () => {
		if (!user?.accessToken || user?.accessToken === '') {
			showLoginModal(languageCode)
			return
		}
		setOpenModal(!openModal)
	}
	const getRulingNumberByToken = async () => {
		if (!user || !user.accessToken) return
		try {
			const checkNumberByToken = await NumerologyApi.getNumerologyDetail(
				user.accessToken
			)
			if (checkNumberByToken) {
				setRulingNumberDetail(checkNumberByToken)
			}
			return
		} catch (error) {
			console.error(error)
		}
	}
	/*
	 * VNW-21084: [Web][Numerlogy] Add "Career path" banner.
	 * Author: PhongGP
	 * Since: 21 Mar, 2023
	 *  */
	const path =
		languageCode === ELanguage.VI ? '/lo-trinh-su-nghiep' : '/career-path'
	const href =
		process.env.VNW_BASE_URL +
		path +
		'?' +
		new URLSearchParams(CAREER_PATH_UTM).toString()

	useEffect(() => {
		getRulingNumberByToken()
	}, [user])

	return (
		<Container>
			<Col>
				<Banner
					banner={`${imgBaseUrl}/numerology/banner-numerology.png`}
					bannerMobile={`${imgBaseUrl}/numerology/banner-numerology-mobile.png`}
					alt='Tra cứu Nhân số học Review to Renew'
				>
					<TopTitle handleOpen={handleOpenModal} />
				</Banner>
			</Col>
			<Col>
				<AboutNumerology handleOpen={handleOpenModal} />
			</Col>
			<Col>
				<RecommendJobs
					title='VIỆC LÀM TỐT NHẤT NHÂN SỐ HỌC GỢI Ý'
					utm={UTM}
				/>
			</Col>
			<Col>
				<FamousPeople
					isRobot={isRobot}
					famousPeople={famousPeople as []}
				/>
			</Col>
			<Col>
				<RulingNumber
					handleOpen={handleOpenModal}
					rulingNumberDetail={rulingNumberDetail}
				/>
			</Col>
			<Col>
				<HistoryNumerology />
			</Col>
			<Col>
				<RCContainer>
					<Article isRobot={isRobot} ssrArticles={articles} />
				</RCContainer>
			</Col>
			<Col>
				<Responsibility />
			</Col>
			<Col>
				<Books />
			</Col>
			<Col>
				<BottomSection
					redirectLink={href}
					backGroundPath={`${IMAGE_SERVICE}/bottom-section-background.png`}
					bannerPath={`${IMAGE_SERVICE}/bottom-section-image.png`}
				/>
			</Col>

			<ModalFormNumerology open={openModal} onClose={handleOpenModal} />
		</Container>
	)
}
